;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('OrderService', OrderService)

  OrderService.$inject = [ '$q', 'PreferencesService', 'OrderManager' ]

  function OrderService ($q, PreferencesService, OrderManager) {
    var self = this

    function createOrderFromPreferences () {
      return $q.all([
        PreferencesService.getCompanyPrefs(),
        PreferencesService.getOrderPrefs()
      ]).then(function (data) {
        var companyPrefs = data[0]
        var orderPrefs = data[1]
        var legalNotices = _.get(companyPrefs, 'companyInfo.name')
        if (_.get(companyPrefs, 'companyInfo.siret')) {
          legalNotices += '<br>'
          legalNotices += 'N° SIRET ' + _.get(companyPrefs, 'companyInfo.siret')
        }
        if (_.get(companyPrefs, 'companyInfo.rcs')) {
          legalNotices += ' RCS ' + _.get(companyPrefs, 'companyInfo.rcs')
        }
        legalNotices += '<br>'
        legalNotices += _.get(companyPrefs, 'companyInfo.address.addressLine1')
        legalNotices += ' '
        legalNotices += _.get(companyPrefs, 'companyInfo.address.postalCode')
        legalNotices += ' '
        legalNotices += _.get(companyPrefs, 'companyInfo.address.city')
        legalNotices += '<br>'
        legalNotices += _.get(companyPrefs, 'companyInfo.phone')
        legalNotices += ' - '
        legalNotices += _.get(companyPrefs, 'companyInfo.website')
        legalNotices += '<br>'
        if (_.get(companyPrefs, 'companyInfo.apeCode')) {
          legalNotices += 'Code APE ' + _.get(companyPrefs, 'companyInfo.apeCode')
        }
        if (_.get(companyPrefs, 'companyInfo.vatIntracom')) {
          legalNotices += ' - N° TVA Intracom. ' + _.get(companyPrefs, 'companyInfo.vatIntracom')
          legalNotices += '<br>'
        }
        if (_.get(companyPrefs, 'companyInfo.iban')) {
          legalNotices += 'IBAN ' + _.get(companyPrefs, 'companyInfo.iban')
          legalNotices += ' '
        }
        if (_.get(companyPrefs, 'companyInfo.swift')) legalNotices += 'SWIFT ' + _.get(companyPrefs, 'companyInfo.swift')
        return OrderManager.create({
          status: 'draft',
          date: new Date(),
          history: [],
          dueDate: moment(new Date()).add(orderPrefs.orderDelay, 'days').toDate(),
          conditions: _.get(orderPrefs, 'defaultConditions', '').replace(/\n/g, '<br>'),
          thanks: _.get(orderPrefs, 'defaultThanks', '').replace(/\n/g, '<br>'),
          legalNotices: legalNotices,
          customFields: {}
        })
      })
    }

    _.extend(self, {
      createOrderFromPreferences: createOrderFromPreferences
    })
  }
})(window.angular, window._, window.moment)
